<div class="card resumo-eventos-page">
    <p-toolbar styleClass="mb-4 resumo-eventos-toolbar">
        <div class="filters-primary">
            <div class="field field-periodo">
                <label for="range" class="filter-label-fixed">Período</label>
                <p-datepicker appendTo="body" dateFormat="dd/mm/yy"
                    [(ngModel)]="rangeDate" selectionMode="range" inputId="range" styleClass="w-full">
                </p-datepicker>
            </div>
            <div class="field field-estacao">
                <label for="estacao" class="filter-label-fixed">Filtro de estações</label>
                <p-multiSelect appendTo="body" inputId="estacao" [filter]="true" filterLocale="pt-BR" [options]="dropDownEstacao"
                    [(ngModel)]="estacao_ids" optionLabel="label" styleClass="w-full">
                </p-multiSelect>
            </div>
            <div class="field field-evento">
                <label for="tipo_evento" class="filter-label-fixed">Filtro de eventos</label>
                <p-multiSelect appendTo="body" inputId="tipo_evento" [filter]="true" [options]="dropDownTipoEvento"
                    [(ngModel)]="tipo_evento_ids" optionLabel="label" optionValue="value" styleClass="w-full">
                </p-multiSelect>
            </div>
            <div class="field field-severidade">
                <label for="severidade" class="filter-label-fixed">Severidade</label>
                <p-dropdown appendTo="body" inputId="severidade" [options]="dropDownSeveridade"
                    [(ngModel)]="severidade_filtro" optionLabel="label" optionValue="value"
                    (onChange)="onSeveridadeFiltroChange()" styleClass="w-full">
                </p-dropdown>
            </div>
            <div class="field field-actions">
                <span class="filter-label-fixed filter-label-actions">&nbsp;</span>
                <div class="actions-group">
                    <button *ngIf="!load" pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button"
                        [disabled]="!rangeDate || rangeDate.length < 2"
                        icon="pi pi-search" class="p-button-rounded p-button-success"></button>
                    <button pButton pRipple type="button" (click)="toggleFiltroAvancado()" pTooltip="Filtro avançado"
                        icon="pi pi-filter" class="p-button-rounded p-button-text p-button-plain"></button>
                    <p-progressSpinner *ngIf="load" [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner"
                        strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                </div>
            </div>

            <div *ngIf="exibirFiltroAvancado" class="filters-advanced">
                <div class="field">
                    <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true" [(ngModel)]="grupo"
                        optionLabel="label" placeholder="Grupos" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true" [(ngModel)]="cliente"
                        optionLabel="label" placeholder="Cliente" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true" [(ngModel)]="sensor"
                        optionLabel="label" placeholder="Sensores (Identificador)" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <input type="text" class="p-inputtext p-component w-full" placeholder="PLU" [(ngModel)]="plu_filtro" pInputText>
                </div>
                <div class="field">
                    <input type="text" class="p-inputtext p-component w-full" placeholder="FLU" [(ngModel)]="flu_filtro" pInputText>
                </div>
                <div class="field">
                    <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                        [(ngModel)]="integrador_filtro" optionLabel="label" placeholder="Integrador" styleClass="w-full">
                    </p-multiSelect>
                </div>
                <div class="field">
                    <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                        [(ngModel)]="coletor_filtro" optionLabel="descricao" placeholder="Coletor" styleClass="w-full">
                    </p-multiSelect>
                </div>
            </div>
        </div>
    </p-toolbar>

    <section class="hero-panel" *ngIf="linhasProblema.length > 0">
        <div class="hero-text">
            <h5>Resumo de eventos irregulares</h5>
            <p *ngIf="periodoFormatado">Período: {{ periodoFormatado }}</p>
            <span class="hero-hint">Exibindo somente ocorrências com valor irregular &gt; 0</span>
            <span class="hero-hint hero-hint-filter" *ngIf="severidade_filtro !== 'ambas'">
                Filtro de severidade: {{ severidade_filtro === 'ALTA' ? 'Alta' : 'Média' }}
            </span>
        </div>
        <div class="kpi-grid kpi-grid-3">
            <div class="kpi-card kpi-card-danger">
                <span class="kpi-value">{{ totalProblemas }}</span>
                <span class="kpi-label">Ocorrências</span>
            </div>
            <div class="kpi-card kpi-card-warning">
                <span class="kpi-value">{{ totalEstacoes }}</span>
                <span class="kpi-label">Estações</span>
            </div>
            <div class="kpi-card kpi-card-info">
                <span class="kpi-value">{{ totalTiposEvento }}</span>
                <span class="kpi-label">Tipos de evento</span>
            </div>
        </div>
    </section>

    <div class="resumo-eventos-table-wrapper">
        <p-table #dt [value]="linhasExibidas" [rows]="25" styleClass="p-datatable-gridlines resumo-problemas-table"
            [paginator]="true" [rowHover]="true" [sortField]="sortField" [sortOrder]="sortOrder"
            [customSort]="true" (sortFunction)="onSortCustom($event)"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} ocorrências"
            [showCurrentPageReport]="true"
            [globalFilterFields]="['estacao_descricao', 'tipo_evento_descricao', 'data_formatada', 'dia_semana', 'severidade']">

            <ng-template pTemplate="caption">
                <div class="table-caption">
                    <div class="caption-title">
                        <h5 class="p-m-0">Resumo de eventos</h5>
                        <span class="caption-subtitle" *ngIf="linhasProblema.length > 0">
                            {{ linhasExibidas.length }} de {{ linhasResumo.length }} ocorrências visíveis
                        </span>
                    </div>
                    <span class="p-input-icon-left search-input">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="buscaGrid" (input)="onBuscaChange()"
                            [disabled]="linhasProblema.length === 0"
                            placeholder="Buscar estação, evento ou data..." />
                    </span>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="data_resumo" style="width: 130px;">
                        Data <p-sortIcon field="data_resumo"></p-sortIcon>
                    </th>
                    <th pSortableColumn="estacao_descricao">
                        Estação <p-sortIcon field="estacao_descricao"></p-sortIcon>
                    </th>
                    <th pSortableColumn="tipo_evento_descricao" style="width: 160px;">
                        Evento <p-sortIcon field="tipo_evento_descricao"></p-sortIcon>
                    </th>
                    <th pSortableColumn="severidade" style="width: 110px; text-align: center;">
                        Severidade <p-sortIcon field="severidade"></p-sortIcon>
                    </th>
                    <th pSortableColumn="irregular" style="width: 90px; text-align: center;">
                        Irregular <p-sortIcon field="irregular"></p-sortIcon>
                    </th>
                    <th style="width: 80px; text-align: center;">Ações</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-linha>
                <tr [ngClass]="classeZebrado(linha)">
                    <td>
                        <span class="p-column-title negrito">Data: </span>
                        <div class="data-cell">
                            <strong>{{ linha.data_formatada }}</strong>
                            <small>{{ linha.dia_semana }}</small>
                        </div>
                    </td>
                    <td>
                        <span class="p-column-title negrito">Estação: </span>
                        <span class="estacao-nome">{{ linha.estacao_descricao }}</span>
                    </td>
                    <td>
                        <span class="p-column-title negrito">Evento: </span>
                        <span class="evento-tag">{{ linha.tipo_evento_descricao }}</span>
                    </td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Severidade: </span>
                        <span class="severidade-badge"
                            [ngClass]="linha.severidade === 'ALTA' ? 'severidade-alta' : 'severidade-media'"
                            [pTooltip]="linha.severidade === 'ALTA' ? 'Severidade alta (ícone laranja no detalhe da estação)' : 'Severidade média (ícone verde no detalhe da estação)'">
                            {{ linha.severidade }}
                        </span>
                    </td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Irregular: </span>
                        <span class="valor-badge valor-irregular">{{ linha.irregular }}</span>
                    </td>
                    <td style="text-align: center;">
                        <span class="p-column-title negrito">Ações: </span>
                        <button pButton pRipple type="button" icon="pi pi-eye"
                            class="p-button-rounded p-button-info p-button-text"
                            pTooltip="Ver detalhes da estação no dia" (click)="abrirDialogEstacao(linha)"></button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">
                        <div class="empty-state">
                            <i class="pi pi-check-circle empty-icon-success" *ngIf="!load && consultaRealizada && linhasProblema.length === 0"></i>
                            <i class="pi pi-exclamation-triangle empty-icon-warn" *ngIf="!load && !consultaRealizada"></i>
                            <i class="pi pi-spin pi-spinner empty-icon-loading" *ngIf="load"></i>
                            <strong *ngIf="!load && !consultaRealizada">Selecione o período e clique em Filtrar</strong>
                            <strong *ngIf="!load && consultaRealizada && linhasProblema.length === 0">Nenhuma ocorrência irregular no período</strong>
                            <strong *ngIf="load">Carregando ocorrências...</strong>
                            <p *ngIf="!load && consultaRealizada && linhasProblema.length === 0">
                                Nenhum evento com valor irregular maior que zero para os filtros aplicados.
                            </p>
                            <p *ngIf="!load && !consultaRealizada">
                                Use os filtros acima para localizar dias com ocorrências irregulares.
                            </p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-dialog [(visible)]="modalEstacao" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
        [modal]="true" [draggable]="false" [resizable]="false" styleClass="station-modal">

        <ng-template pTemplate="header">
            <div class="modal-header-content">
                <a [routerLink]="['/dashboard/', estacaoDialog?.id, dataRotaModal]" class="modal-header-link">
                    <i class="pi pi-external-link modal-header-icon"></i>
                    <h5 class="modal-header-title">{{ tituloModalEstacao }}</h5>
                </a>
            </div>
        </ng-template>

        <div class="modal-content">
            <div class="station-info-card" *ngIf="estacaoDialog">
                <div class="station-info-header">
                    <i class="pi pi-info-circle station-info-icon"></i>
                    <h6 class="station-info-title">Informações da Estação</h6>
                </div>
                <div class="station-info-body">
                    <div class="info-row">
                        <span class="info-label">ID:</span>
                        <span class="info-value">{{ estacaoDialog?.id }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Cód. PLU:</span>
                        <span class="info-value">{{ estacaoDialog?.plu }}</span>
                        <span class="info-label info-label-spaced">Cód. FLU:</span>
                        <span class="info-value">{{ estacaoDialog?.flu }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Localização:</span>
                        <span class="info-value">{{ estacaoDialog?.latitude }}, {{ estacaoDialog?.longitude }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="loadingDialogEstacao" class="dialog-loading-state">
                <p-progressSpinner [style]="{width: '56px', height: '56px'}" strokeWidth="6"
                    fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
                <p>Carregando detalhes da estação...</p>
            </div>

            <div class="p-fluid grid modal-sections" *ngIf="!loadingDialogEstacao">
                <div class="col-12 md:col-6">
                    <div class="events-card">
                        <div class="card-header">
                            <i class="pi pi-calendar-times card-header-icon"></i>
                            <h6 class="card-header-title">Eventos</h6>
                        </div>
                        <div class="card-body">
                            <div *ngFor="let item of dadosDialogEstacao">
                                <p-message *ngIf="item.eventos.length === 0" severity="info"
                                    text="Nenhum evento encontrado." styleClass="empty-message"></p-message>
                                <div *ngFor="let row of item.eventos" class="event-row">
                                    <div class="event-icon">
                                        <i [ngClass]="getIconeEvento(row)" [ngStyle]="{'color': row.cor}"></i>
                                    </div>
                                    <div class="event-content">
                                        <span class="event-name">{{ row.tipo_evento.descricao }}</span>
                                        <span class="event-count" [pTooltip]="row.tooltip">
                                            {{ row.total_computado }} / {{ row.maximo_normalidade_eventos }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <div class="monitoring-card">
                        <div class="card-header monitoring-card-header">
                            <div class="card-header-title-group">
                                <i class="pi pi-eye card-header-icon"></i>
                                <h6 class="card-header-title">Monitoramentos</h6>
                            </div>
                            <button *ngIf="podeAbrirMonitoramento" pButton pRipple type="button"
                                icon="pi pi-plus"
                                label="Novo"
                                class="p-button-sm p-button-outlined monitoring-new-btn"
                                pTooltip="Criar novo monitoramento"
                                [disabled]="loadingDialogEstacao || !estacaoDialog?.id"
                                (click)="abrirNovoMonitoramentoEstacao($event)"></button>
                        </div>
                        <div class="card-body">
                            <div *ngFor="let item of dadosDialogEstacao">
                                <p-message *ngIf="item.monitoramento.length === 0" severity="info"
                                    text="Nenhum monitoramento encontrado." styleClass="empty-message"></p-message>
                                <div *ngFor="let row of item.monitoramento" class="monitoring-row"
                                    [class.monitoring-row-clickable]="podeAbrirMonitoramento && !!row.id"
                                    (click)="abrirMonitoramentoEstacao(row)">
                                    <div class="monitoring-icon">
                                        <i [ngClass]="getIconeMonitoramento(row)" [ngStyle]="{'color': row.cor}"></i>
                                    </div>
                                    <div class="monitoring-content">
                                        <span class="monitoring-name">{{ row.tipo_evento }}</span>
                                        <span class="monitoring-dates" pTooltip="Inicio / Fim">
                                            {{ row.data_hora_monitoramento }} / {{ row.data_hora_ultima_situacao }}
                                        </span>
                                    </div>
                                    <span class="monitoring-status"
                                        [class.monitoring-status-open]="monitoramentoEstaAberto(row)"
                                        [class.monitoring-status-closed]="!monitoramentoEstaAberto(row)">
                                        {{ monitoramentoEstaAberto(row) ? 'Aberto' : 'Fechado' }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="modal-footer">
                <button pButton pRipple type="button" icon="pi pi-table" (click)="abrirLeiturasEstacao()"
                    label="Ver leituras do dia" class="p-button-outlined p-button-info"
                    [disabled]="loadingDialogEstacao || !estacaoDialog?.id"></button>
                <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="changeDateDialogEstacao('ontem')"
                    label="Data anterior" class="p-button-outlined"></button>
                <button pButton pRipple type="button" (click)="changeDateDialogEstacao('amanha')" iconPos="right"
                    icon="pi pi-arrow-right" label="Próxima data" class="p-button-outlined"></button>
            </div>
        </ng-template>
    </p-dialog>

    <app-leitura-estacao-dialog></app-leitura-estacao-dialog>
    <app-eventos-monitoramentos-dialog
        (saved)="onMonitoramentoSalvo()">
    </app-eventos-monitoramentos-dialog>
</div>
